import country from './country';
import state from './state';

export default {
  country,
  state,
};
